import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import plugins from "@/plugins";
import { i18n } from "@/translations";
import vueHeadful from "vue-headful";

// fbq
Vue.prototype.$fbq = window.fbq;

import sendEvent, { initFbcTracking, resolveDonorData, resolveFbc, resolveFbp } from "@/helpers/sendEvent";
initFbcTracking();

// change whatsAppNo
Vue.component("vue-headful", vueHeadful);
//window.whatsAppNo = 'https://wa.me/+96596000170?text=';
window.whatsAppNo = "https://wa.me/+96596000170?text=";

/* Copy to Clipboard */
import VueClipboard from "vue-clipboard2";
VueClipboard.config.autoSetContainer = true; // add this line
Vue.use(VueClipboard);
/* End Copy to Clipboard */

// baseURL
window.baseURL = process.env.VUE_APP_baseURL;
// window.baseURL = "https://api.childrensheart.org.kw/v1";
Vue.config.productionTip = false;

// index.html fires the initial browser PageView with window._initialPvId.
// We pair it with CAPI on first navigation, and generate matched IDs for all SPA transitions
// to ensure 100% event deduplication between browser pixel and server CAPI.
let isFirstNavigation = true;
router.afterEach((to) => {
  // Use nextTick to ensure the document title has updated (if using vue-headful)
  Vue.nextTick(() => {
    // --- A. Google Tracking ---
    if (window.gtag) {
      // 1. Existing Google Analytics (GA4)
      window.gtag("config", "G-8PX8TSG7YV", {
        page_path: to.fullPath,
      });

      // 2. Google Ads
      window.gtag("config", "AW-17693901756", {
        page_path: to.fullPath,
        page_title: document.title,
      });
    }

    // --- B. Meta (Facebook) Pixel + CAPI Deduplication ---
    // Use the shared ID from index.html on initial page load, or generate a fresh shared ID on route change.
    const pageViewEventId =
      (isFirstNavigation && window._initialPvId) ||
      `pv_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;

    // Browser pixel: skip first navigation because index.html already fired it with window._initialPvId.
    // On subsequent navigations, fire fbq with the shared eventID.
    if (window.fbq && !isFirstNavigation) {
      window.fbq("track", "PageView", {}, { eventID: pageViewEventId });
    }

    // CAPI (server-side): ALWAYS send, including first navigation, passing the exact same event_id
    // for seamless deduplication against the browser pixel event.
    try {
      const fbc = resolveFbc();
      const fbp = resolveFbp();
      const donorData = resolveDonorData({});
      sendEvent("PageView", 0, "KWD", {
        ...donorData,
        fbc,
        fbp,
        event_id: pageViewEventId,
      });
    } catch (e) {}

    // Consume the initial ID once processed
    if (isFirstNavigation) {
      window._initialPvId = null;
      isFirstNavigation = false;
    }
  });
});

new Vue({
  i18n,
  plugins,
  router,
  render: (h) => h(App),
}).$mount("#app");
